import BackgroundImage from '../../../src/modules/BackgroundImage';

customElements.define(

  "cc-product-link-card", 

  class extends HTMLElement{

    connectedCallback(){

        const imageURL = this.getAttribute("image");
        let label = this.getAttribute("label");
        let description = this.getAttribute("description");
        let href = this.getAttribute("href");

        const element = this.innerHTML;

        if( label == "" || !label){
            label = "Product Name";
        }

        if( description == "" || !description ){
            description = "Product description.";
        }

        if( href == "" || !href ){
            href = "#";
        }

        this.innerHTML = `
        <a id="cc-product-link-card" href="${href}">

            <div id="product-image">
    
            </div>
            <div id="product-information">

                <h3>${label}</h3>

                <p>${description}</p>

                ${element}
                
            </div>


        </a>      

        `;

        let imageContainer = this.querySelector("#product-image");

        if (imageContainer && imageURL != "" ) { 

            new BackgroundImage(imageURL, imageContainer);

        }

    }
       
  }

);